import React from 'react';
import { Award, Target, Zap, DollarSign } from 'lucide-react';

const benefits = [
  {
    icon: Award,
    title: 'Experienced Team',
    description: 'Expert growth hackers with proven track records across multiple industries'
  },
  {
    icon: Target,
    title: 'Focus on Conversion',
    description: 'Data-driven strategies that turn visitors into loyal customers'
  },
  {
    icon: Zap,
    title: 'Lean Growth Process',
    description: 'Agile methodology that delivers results quickly and efficiently'
  },
  {
    icon: DollarSign,
    title: 'Fixed Low Price',
    description: 'Transparent pricing with no hidden costs or surprises'
  }
];

const Benefits = () => {
  return (
    <section id="benefits" className="py-20 px-4 sm:px-6 lg:px-8 bg-gradient-to-b from-white to-blue-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16 space-y-4">
          <h2 className="text-4xl sm:text-5xl font-bold text-gray-900">
            Benefits of <span className="text-blue-600">working with us</span>
          </h2>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {benefits.map((benefit, index) => {
            const Icon = benefit.icon;
            return (
              <div
                key={index}
                className="text-center space-y-4 group cursor-pointer"
              >
                <div className="inline-flex items-center justify-center w-20 h-20 bg-white rounded-2xl shadow-lg group-hover:shadow-xl group-hover:scale-110 transition-all duration-300">
                  <Icon className="w-10 h-10 text-blue-600" />
                </div>
                <h3 className="text-xl font-bold text-gray-900 group-hover:text-blue-600 transition-colors">
                  {benefit.title}
                </h3>
                <p className="text-gray-600">
                  {benefit.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Benefits;